module.exports = __webpack_public_path__ + "img/tpshop.92537f4a.png";